import React, { useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { filteredRow } from "../../../utils/dataTransformer";
import AgGrid from "../../Table/AgGrid";

const RevenuePermission = ({ columnDefs, priviledgeList, resource }) => {
  const gridRef = useRef();
  const { t } = useTranslation();

  const useFilteredRows = useCallback(() => {
    const rows = [
      {
        functionName: "QUOTATION",
        name: t("sales.quotation.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "ORDER",
        name: t("sales.order.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "RETURN",
        name: t("sales.return.index"),
        view: "view",
        create: "create",
        edit: "edit",
        cancel: "cancel",
      },
      {
        functionName: "REPORT",
        name: t("sales.report.index"),
        view: "view",
      },
    ];
    return filteredRow(rows, priviledgeList, resource);
  }, [priviledgeList, resource, t]);

  return (
    <AgGrid
      rowData={useFilteredRows()}
      ref={gridRef}
      columnDefs={columnDefs}
      autoHeight
      isClientSide
    />
  );
};

export default RevenuePermission;
